export const Log_In = "Log_In";
export const Sign_Up = "Sign_Up";
export const Load_User = "Load_User";
export const Auth_Error = "Auth_Error";
export const Log_Out = "Log_Out";